export default "__VITE_ASSET__CKXUH3bh__"